var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetingsTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9209 3.22743C10.6227 1.2672 7.02152 1.11751 4.52336 2.88982C2.05089 4.64391 1.45455 7.70603 3.05335 10.0706C3.15374 10.2191 3.17936 10.4058 3.12269 10.5758L2.44204 12.6178L5.06926 12.0588C5.19476 12.0321 5.32558 12.048 5.44101 12.1041C8.26193 13.4736 11.7724 12.7602 13.6408 10.4935C15.4833 8.25824 15.1919 5.16441 12.9209 3.22743ZM3.85622 1.94944C6.77851 -0.123777 10.9632 0.0422209 13.6691 2.35019C16.4023 4.6814 16.7869 8.48947 14.5305 11.2269C12.3413 13.8829 8.35416 14.6967 5.11964 13.2269L1.69648 13.9552C1.49424 13.9982 1.28445 13.9297 1.14666 13.7755C1.00888 13.6213 0.964209 13.4052 1.02959 13.209L1.94144 10.4735C0.169222 7.5917 0.989395 3.9833 3.85622 1.94944ZM5.41983 6.66535C5.73822 6.66535 5.99633 6.92345 5.99633 7.24185V7.24953C5.99633 7.56792 5.73822 7.82603 5.41983 7.82603C5.10144 7.82603 4.84333 7.56792 4.84333 7.24953V7.24185C4.84333 6.92345 5.10144 6.66535 5.41983 6.66535ZM8.49449 6.66535C8.81288 6.66535 9.07099 6.92345 9.07099 7.24185V7.24953C9.07099 7.56792 8.81288 7.82603 8.49449 7.82603C8.1761 7.82603 7.91799 7.56792 7.91799 7.24953V7.24185C7.91799 6.92345 8.1761 6.66535 8.49449 6.66535ZM11.5691 6.66535C11.8875 6.66535 12.1456 6.92345 12.1456 7.24185V7.24953C12.1456 7.56792 11.8875 7.82603 11.5691 7.82603C11.2508 7.82603 10.9926 7.56792 10.9926 7.24953V7.24185C10.9926 6.92345 11.2508 6.66535 11.5691 6.66535Z",
    fill: "#051123",
    stroke: "#051123",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingsTag);
export default __webpack_public_path__ + "static/media/meetings_tag.4840cf077cc1f242b244aada216e506e.svg";
export { ForwardRef as ReactComponent };